import * as types from './types';

const INITIAL_STATE = {
  fetchRecipesLoading: false,
  removeIngredientLoading: false,
  replaceIngredientLoading: false,
  fetchRecipesError: null,
  removeIngredientError: null,
  replaceIngredientError: null,
  isSubmitSuccess: false,
  recipes: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES_LOADING:
      return { ...state, fetchRecipesLoading: payload };
    case types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES:
      return { ...state, recipes: payload };
    case types.REMOVE_REPLACE_INGREDIENT_CLEAR_RECIPES:
      return { ...state, recipes: [] };
    case types.REMOVE_REPLACE_INGREDIENT_GET_RECIPES_ERROR:
      return { ...state, fetchRecipesError: payload };
    case types.REMOVE_REPLACE_INGREDIENT_CLEAR_ERRORS:
      return {
        ...state,
        fetchRecipesError: null,
        removeIngredientError: null,
        replaceIngredientError: null,
      };
    case types.REMOVE_REPLACE_INGREDIENT_SET_SUBMIT_SUCCESS:
      return { ...state, isSubmitSuccess: payload };
    case types.REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_LOADING:
      return { ...state, removeIngredientLoading: payload };
    case types.REMOVE_REPLACE_INGREDIENT_REMOVE_INGREDIENT_ERROR:
      return { ...state, removeIngredientError: payload };
    case types.REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_ERROR:
      return { ...state, replaceIngredientError: payload };
    case types.REMOVE_REPLACE_INGREDIENT_REPLACE_INGREDIENT_LOADING:
      return { ...state, replaceIngredientLoading: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/removereplaceingredient/reducer.js